import Header from './Header'
import Footer from './Footer'
import Slideshow from './Slideshow'
import ScrollArea from './ScrollArea'

export default {
  Header,
  Footer,
  Slideshow,
  ScrollArea
}



// WEBPACK FOOTER //
// ./src/components/partials/index.js